export const WEBSITE_DOMAINS = {
  town: 'trev.town',
  full: 'trevormcdougald.com',
  land: 'trevor.land',
  fyi: 'trev.fyi',
};

export const DOMAIN = WEBSITE_DOMAINS.fyi;
